import axios from '@/axios.js'

export default {
  // eslint-disable-next-line no-unused-vars
  getCompany (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v1/company')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  findCompany (context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/company/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createCompany (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v1/company', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCompany (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/v1/company/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteCompany (context, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/v1/company/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
